import Currency from "../components/common/currency";

const CurrencyPage = () => {
  return <Currency />;
};

export default CurrencyPage;